import { localize } from '../i18n';
import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { colors } from '../design/tokens';

// 앱의 WebView 시작 로더와 같은 화면 중심, 색상, 명목 크기를 사용한다.
export default function PageLoading({ backgroundColor = colors.canvas }) {
    return (
        <Box role="status" aria-label={localize("화면을 불러오는 중")} sx={{
            position: 'fixed',
            inset: 0,
            width: '100%',
            maxWidth: 480,
            mx: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: backgroundColor,
            zIndex: 1,
        }}>
            <CircularProgress size={36} sx={{ color: colors.brandDark }} />
        </Box>
    );
}
